import { Canvas } from "@react-three/fiber";
import React from "react";
import TiltCard from "../components/TiltCard";
import Box from "../components/Box";
import { OrbitControls } from "@react-three/drei";

const About = () => {
  const items = [];
  for (let i = 0; i < 50; i++) {
    items.push(<li key={i}>Item {i}</li>);
  }
  return (
    <div className="m-auto relative z-50">
      <div className="h-96 flex relative z-50">
        <Canvas
          className="relative z-50"
          camera={{
            position: [0, 0, 10],
            fov: 70,
          }}
        >
          <ambientLight intensity={0.5} />
          <spotLight position={[0, 0, 0]} angle={2} penumbra={1} />
          <pointLight position={[-10, -10, -10]} />
          {items.map((item, index) => {
            return (
              <Box
                position={[
                  Math.random() * 21 - 10,
                  Math.random() * 21 - 10,
                  Math.random() * 21 - 10,
                ]}
                color={`hsl(${Math.random() * 360}, 50%, 50%)`}
                rnd1={Math.random() * 0.01}
                rnd2={Math.random() * 0.01}
              />
            );
          })}

          <OrbitControls
            enablePan={false}
            enableZoom={false}
            enableRotate={false}
          />
        </Canvas>
        <div className="w-1/2 m-auto ml-28">
          <h1 className="text-white text-2xl font-bold mt-4 mb-4">About Me</h1>
          <p className="text-white text-lg font-medium mb-4 text-justify mr-5">
            Hello! I am a software developer and I entered the software world in
            2015. Since then, I have gained experience in technologies such as
            JavaScript, Flutter, React, Express.js, and .NET. Software
            development has always been my area of interest and the continuous
            developments in the industry have always excited me. I am passionate
            about my work and always strive to learn more. That's why I am
            constantly open to new technologies and advancements.
          </p>
        </div>
      </div>
      <div className="mt-20 flex flex-wrap gap-10 content-center justify-center mb-20">
        <TiltCard
          title="Frontend Developer"
          imgUrl="https://cdn-icons-png.flaticon.com/512/2888/2888704.png"
          number={Math.floor(Math.random() * 3 + 1)}
        />
        <TiltCard
          title="Backend Developer"
          imgUrl="https://cdn-icons-png.flaticon.com/512/2821/2821637.png"
          number={Math.floor(Math.random() * 3 + 1)}
        />
        <TiltCard
          title="Mobile Developer"
          imgUrl="https://cdn-icons-png.flaticon.com/512/2645/2645725.png"
          number={Math.floor(Math.random() * 3 + 1)}
        />{" "}
        <TiltCard
          title="UI/UX Designer"
          imgUrl="https://cdn-icons-png.flaticon.com/512/2704/2704271.png"
          number={Math.floor(Math.random() * 3 + 1)}
        />
      </div>
    </div>
  );
};

export default About;
